import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformKeysToSnakeCase, transformClientResponse, transformValues } from 'helpers/core';

const valueMap = {
  yes: true,
  no: false,
};

function post(httpClient, data) {
  const { settings } = data;
  const payload = {
    settingChanges: settings,
  };

  return httpClient.post(URLS.user.settings, transformKeysToSnakeCase(payload));
}

function get(httpClient) {
  return httpClient
    .get(URLS.user.settings)
    .then(transformClientResponse)
    .then(data =>
      transformValues(data, v => {
        return valueMap.hasOwnProperty(v) ? valueMap[v] : v; // eslint-disable-line no-prototype-builtins
      })
    );
}

function handler({ httpClient }, data) {
  let promise = Promise.resolve();

  if (data) {
    promise = post(httpClient, data);
  }

  return promise.then(() => get(httpClient));
}

export default makeEntityScaffold('USER_SETTINGS', handler);
